import React from 'react';
import RadioList from '../../../RadioList/RadioList';
import { FilterData } from '../../../FilterForm/FilterForm';
import { FilterByListOfAvailableValues } from '../../../../types/types';

interface IFilterSelectProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByListOfAvailableValues;
  filterData?: FilterData;
}

export default function FilterSelect({
  onChange,
  filter,
  filterData,
}: IFilterSelectProps) {
  const handleSingleChange = (newVal: string) => {
    onChange({ id: filter.id, values: [newVal] });
  };

  const value =
    filterData?.values && filterData.values[0] ? filterData.values[0] : '';

  return (
    <RadioList
      onChange={handleSingleChange}
      items={filter.availableValues}
      value={value}
    />
  );
}
